import {Icon} from "@components/Icons/PersonalInfoCheck.elements";
import React from "react";

type Props = {
  className?: string
}

export const PersonalInfoCheckIcon = ({ className }: Props) => (
  <Icon
    viewBox="0 0 48 48"
    aria-hidden
    focusable={false}
    role="img"
    className={className}
    fill="none"
  >
    <path d="M41 23.5V7.56C41 6.69844 40.3016 6 39.44 6H6.56C5.69844 6 5 6.69844 5 7.56V36.44C5 37.3016 5.6986 38 6.56017 38C14.3492 38 20.2678 38 26.6306 38" stroke="#1A1C1F" strokeWidth="1.2"/>
    <line x1="25" y1="17.4" x2="37" y2="17.4" stroke="#1A1C1F" strokeWidth="1.2"/>
    <line x1="25" y1="25.4" x2="29" y2="25.4" stroke="#1A1C1F" strokeWidth="1.2"/>
    <line x1="25" y1="21.4" x2="37" y2="21.4" stroke="#1A1C1F" strokeWidth="1.2"/>
    <ellipse cx="15.1989" cy="17.9201" rx="2.86" ry="2.86" stroke="#1A1C1F" strokeWidth="1.2"/>
    <path d="M20.2043 26.5001C20.2043 23.7359 17.9635 21.4951 15.1993 21.4951C12.4352 21.4951 10.1943 23.7359 10.1943 26.5001" stroke="#1A1C1F" strokeWidth="1.2"/>
    <path d="M37.0003 42.3332C41.6027 42.3332 45.3337 38.6022 45.3337 33.9998C45.3337 29.3975 41.6027 25.6665 37.0003 25.6665C32.398 25.6665 28.667 29.3975 28.667 33.9998C28.667 38.6022 32.398 42.3332 37.0003 42.3332Z" stroke="#4CA9ED" strokeWidth="1.2"/>
    <path d="M33.5273 33.8521L36.0987 36.4234L41.2999 31.2222" stroke="#4CA9ED" strokeWidth="1.2"/>
  </Icon>
)
